import React, { Dispatch, SetStateAction, useState } from "react";
import Button from "react-bootstrap/Button";
import Title from "../../../../../components/Title";
import RlCloudSandboxProcessTreeItem from "./RlCloudSandboxProcessTreeItem";
import {
  BehavioralProcess,
  ProcessTree,
  ProcessTreeItem
} from "../../../@types/rldynamicanalysis";

type RlCloudSandboxProcessTreeProps = {
  data: ProcessTreeItem[];
  activeItem: BehavioralProcess | null;
  setActiveItem: Dispatch<SetStateAction<BehavioralProcess>>;
};

const DEFAULT_NUMBER_OF_VISIBLE_ITEMS = 8;

const RlCloudSandboxProcessTree = ({
  data,
  ...props
}: RlCloudSandboxProcessTreeProps) => {
  const [treeExpanded, setTreeExpanded] = useState<boolean>(false);
  const limitProcessTreeHeight = data.length > DEFAULT_NUMBER_OF_VISIBLE_ITEMS;

  return (
    <div className="process-tree__container">
      <Title
        text="Process Tree"
        Level="h3"
        contentRight={
          limitProcessTreeHeight && (
            <Button
              style={{ marginLeft: "auto", minWidth: "initial" }}
              variant="primary"
              size="sm"
              onClick={() => setTreeExpanded(!treeExpanded)}
            >
              {treeExpanded ? "Collapse" : "Expand"}
            </Button>
          )
        }
      />
      <ul
        className={`process-tree ${
          limitProcessTreeHeight &&
          !treeExpanded &&
          "process-tree--limited-height"
        }`}
      >
        {data?.map((process: ProcessTree, processIndex: number) => (
          <RlCloudSandboxProcessTreeItem
            process={process}
            key={processIndex}
            {...props}
          />
        ))}
      </ul>
    </div>
  );
};

export default RlCloudSandboxProcessTree;
